/* eslint-disable react/no-danger */
import React from "react";
import { useIntl, Link } from "gatsby-plugin-intl";
import PageSection from "components/PageSection";
import kioskBoothLeftRight from "images/kioskBoothLeftRight.png";
import kioskBoothRightLeft from "images/kioskBoothRightLeft.png";
import Button from "components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import IconedList from "components/IconedList";
import checkIcon from "icons/check.svg";
import { gtagsActions, gtagsCategories, gtagsSend } from "utils/gtagsUtils";

const bulletListData = [
  {
    icon: checkIcon,
    intlTitle: "becomeFranchisee.mainPage.section.whyBecomeFranchisee",
    intlListItems: [
      "becomeFranchisee.mainPage.section.description.highEnd.services",
      "becomeFranchisee.mainPage.section.description.ecoSystem",
      "becomeFranchisee.mainPage.section.description.team",
    ],
  },
  {
    icon: checkIcon,
    intlTitle: "becomeFranchisee.mainPage.section.howToBecomeFranchisee",
    intlListItems: [
      "becomeFranchisee.mainPage.section.description.adhereToValuesPrinciples",
      "becomeFranchisee.mainPage.section.description.haveFinancialBase",
      "becomeFranchisee.mainPage.section.description.haveWellLocatedBooth",
    ],
  },
];

const BecomeFranchiseeSection = () => {
  const { formatMessage, locale } = useIntl();

  return (
    <PageSection
      className="py-40"
      id="partner-and-testimonials"
      startIconTo="partner-and-testimonials"
    >
      <div className="flex flex-col franchisee-section w-full gap-10">
        <h2
          className="text-2dot5xl font-bold px-16 xl:px-main-page z-20 sm:text-4xl md:text-5xl xl:text-6xl mb-4"
          dangerouslySetInnerHTML={{
            __html: formatMessage({
              id: "becomeFranchisee.title",
            }),
          }}
        />

        <div className=" relative cards-container flex flex-col xl:flex-row-reverse xl:justify-between xl:items-center">
          <div className=" pl-16 rtl:pl-0 rtl:pr-16 ml-auto rtl:ml-0 rtl:mr-auto relative z-20 xl:w-5/12 xl:p-0 xl:center ">
            <img
              src={locale === "fr" ? kioskBoothRightLeft : kioskBoothLeftRight}
              alt="kioskBooth"
              className="relative w-full ltr:ml-auto rtl:mr-auto md:w-4/5 xl:w-full"
            />
            <div className="w-full hidden xl:block mt-8">
              <Button
                component={Link}
                variant="default"
                className="mx-auto w-4/6 "
                to="/become-franchisee"
                startIcon={<FontAwesomeIcon icon={faHome} />}
                onClick={() =>
                  gtagsSend(gtagsCategories.LEAD, gtagsActions.BECOME_FRANCHISE)}
              >
                {formatMessage({ id: "paragraph.agency.buttonLabel" })}
              </Button>
            </div>
          </div>

          <div className=" bg-secondary text-white p-16 pt-32 -mt-16 w-full xl:mt-0 xl:w-7/12 xl:py-12 xl:px-main-page xl:rounded-r-large  xl:self-end xl:rtl:rounded-r-none xl:rtl:rounded-l-large">
            <IconedList data={bulletListData} />

            <div className="w-full xl:hidden mt-32">
              <Button
                component={Link}
                variant="default"
                className="w-full sm:w-3/4 sm:mx-auto md:w-2/4"
                to="/become-franchisee"
                startIcon={<FontAwesomeIcon icon={faHome} />}
              >
                {formatMessage({ id: "paragraph.agency.buttonLabel" })}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </PageSection>
  );
};

export default BecomeFranchiseeSection;
